import { position } from "@chakra-ui/react";
import FindInStore from "../../../components/find-in-store-content";

export default {
    parts: [
        'container',
        'content',
        'info',
        'name',
        'address',
        'hours',
        'ctas',
        'cta',
        'customClose'
    ],
    baseStyle: (props) => ({
        container: {
            position: 'absolute',
            bottom: '0',
            width: '100%',
            backgroundColor: 'white',
            padding: 4
        },
        content: {
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'space-between',
            gap: 4
        },
        info: {
            marginBottom: 2
        },
        name: {
            fontSize: { base: 'md' },
            lineHeight: { base: '20px' },
            fontWeight: { base: 'bold' },
            textTransform: { base: 'uppercase' }
        },
        address: {
            fontSize: { base: 'sm' },
            lineHeight: { base: '18px' },
        },
        hours: {
            marginBottom: 2,
            fontSize: { base: 'xs' },
            lineHeight: { base: '15px' },
        },
        ctas: {
            display: 'flex',
            flexWrap: 'no-wrap',
            gap: 2,
            maxWidth: '343px',
            marginTop: 6
        },
        cta: {
            fontSize: 'sm',
            lineHeight: '14px',
            padding: '14.5px 0',
            height: 'auto',
            width: '100%',
            _hover: {
                textDecoration: 'none'
            }
        }
    }),

    variants: {
        FindInStore: (props) => ({
            container: {
                paddingTop: '48px'
            },
            content: {
                position: 'relative'
            },
            customClose: {
                position: 'absolute',
                right: '0',
                top: '-40px',
                cursor: 'pointer'
            }
        })
    }
}
